import { Address, createPublicClient, getContract, http } from 'viem';
import { mainnet } from 'viem/chains';

const viemPublic = createPublicClient({
  chain: mainnet,
  transport: http(),
});

/**
 * Validate ABI
 * @param abi - ABI
 * @param address - Address
 * @returns boolean
 */
export const validateAbi = (abi: string, address: Address): boolean => {
  try {
    // If can't get the contract tract mean the ABI is invalid
    const _contract = getContract({
      abi: JSON.parse(abi),
      address: address,
      client: viemPublic,
    });
    return true;
  } catch (err) {
    return false;
  }
};
